const hostname = (typeof window !== 'undefined' && window.location && window.location.hostname)
  ? window.location.hostname.toLowerCase()
  : ''

export const isMd = hostname.includes('.md')

export const DEFAULT_LANG = isMd ? 'ro' : 'uk'

export const DEBOUNCE_REQUESTS = 150
